/* SLIDE 6 */
/* SLIDE 7 */

import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import settingIcon from "assets/icons/settingIcon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setParkingSpots,
  setSelectedSpots,
  clearSelectedSpots,
  fetchAllParkingSpots,
  setSelectedSpot,
  setParkingSpaceView,
} from "features/parking/presentation/store/parkingSlice";
import SearchBar from "shared/components/SearchBar";
import SubHeader from "shared/components/SubHeader";
import { splitCarNumber, numberFormat, datetimeFormat } from "../../../utils/common";
import { searchCar, getParkingSpaceList } from "../usecases/ParkingUsecases";
import { checkFee } from "features/parking/usecases/CarInOutUsecases";
import AppInfoRow from "shared/components/AppInfoRow";
import Popup from "shared/components/Popup";
import Loading from "../../../shared/components/Loading";
import { DateTime } from "luxon";
import InfiniteScroll from "react-infinite-scroll-component";
import { ThreeDots } from "react-loader-spinner";
import AppInfiniteScroll from "../../../shared/components/AppInfiniteScroll";
import ToggleComponent from "../../../shared/components/ToggleComponent";
import Skeleton from 'react-loading-skeleton';
import IconClock from "assets/icons/iconClock.svg";


const ParkingStatusPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const [result, setResult] = useState(null);
  const [isSearched, setIsSearched] = useState(false);
  const [tableWidth, setTableWidth] = useState(1000);
  const [showPopupPrice, setShowPopupPrice] = useState(false);
  const [entryData, setEntryData] = useState(null);
  const [loadingEntryData, setLoadingEntryData] = useState(false);

  const topScrollRef = useRef(null);
  const tableScrollRef = useRef(null);
  const isScrolling = useRef(false);
  const didMountRef = useRef(false);

  const { selectedSpots, parkingSpots, parkingName, loading, parkingSpaceView, selectedSpot } = useSelector((state) => state.parking);
  const { user } = useSelector((state) => state.auth);

  const navigation = useNavigate();
  const dispatch = useDispatch();

  const fetchCheckOutFee = async () => {

    setLoadingEntryData(true);
    try {
      const extraSpace = duplicateStatus[selectedSpot?.spaceNumber - 1]

      const response = await checkFee({
        parkingId: user.parkingId,
        carNumber: selectedSpot.carNum,
        facilityId: "00003",
        extraSpace: extraSpace
      });
      setEntryData(response);
    } catch (error) {
      console.error("Error fetching checkout fee:", error);
    } finally {
      setLoadingEntryData(false);
    }
  };

  useEffect(() => {
    if (didMountRef.current) {
      if (selectedSpot?.entryId) {
        // fetchCheckOutFee();
      }
    } else {
      didMountRef.current = true;
    }
  }, [selectedSpot]);

  useEffect(() => {
    if (tableScrollRef.current) {
      const table = tableScrollRef.current.querySelector("table");
      if (table) {
        const width = table.scrollWidth;
        setTableWidth(width);
      }
    }
  }, [parkingSpaceView]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const input = document.getElementById("search-input");
      const dropDownList = document.getElementById("search-dropdown");
      if (input && !input.contains(event.target) && dropDownList && !dropDownList.contains(event.target)) {
        setIsSearched(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(clearSelectedSpots());
    dispatch(fetchAllParkingSpots({ parkingId: user.parkingId }));
  }, []);

  const showDropdown = () => {
    if (searchValue) {
      setIsSearched(true);
    }
  };

  const handleSettingsClick = () => {
    navigation("/parking_setting");
  };

  const handleSlotClick = useCallback((spaceNumber) => {
    console.log("Clicked parking slot:", spaceNumber);
    const spot = parkingSpots?.find((s) => s.spaceNumber == spaceNumber);
    if (!spot || spot.carNum) {
      return;
    }

    dispatch(setSelectedSpots(spaceNumber));

  }, []);

  const handleEnterParking = () => {
    if (selectedSpots.length === 0) {
      return;
    }

    dispatch(setSelectedSpot(null));

    navigation("/parking_check", {
      state: {
        selectedSpots,
        selectedSpotState: parkingSpots?.find((spot) => spot.spaceNumber === selectedSpots[0]),
      },
    });
  };

  const handleClearSearch = async () => {
    setSearchValue("");
    setIsSearched(false);
    setResult(null);
    const data = await getParkingSpaceList({ parkingId: user.parkingId });

    dispatch(setParkingSpots(data.fullSlotList));
  };

  const handleSearch = async () => {
    try {
      dispatch(clearSelectedSpots());
      if (searchValue === "") {
        const data = await getParkingSpaceList({ parkingId: user.parkingId });
        setResult(null);
        setIsSearched(false);
        dispatch(setParkingSpots(data.fullSlotList));
      } else {
        const data = await searchCar({ parkingId: user.parkingId, carNumber: searchValue });
        setResult(data.list);
        setIsSearched(true);
        dispatch(setParkingSpots(data.usedSlot));
      }
    } catch (err) {
      console.error("Search failed", err);
    }
  };

  const handleScroll = (sourceRef, targetRef) => {
    if (isScrolling?.current) return;

    isScrolling.current = true;
    if (sourceRef?.current && targetRef?.current) {
      targetRef.current.scrollLeft = sourceRef?.current?.scrollLeft;
    }
    isScrolling.current = false;
  };

  const refreshFunction = () => {
    dispatch(fetchAllParkingSpots({ parkingId: user.parkingId }));
  }

  const handleClick = useCallback(
    (spot) => {
      if (spot.entryId) {
        dispatch(setSelectedSpot(spot));
        navigation('/parking_check_success', {
          state: {
            selectedSpots,
            selectedSpotState: spot,
          },
        });
      } else {
        console.log(selectedSpots.length)
        console.log('Clicked parking slot:', spot);
        dispatch(setSelectedSpot(spot));
        dispatch(setSelectedSpots(spot?.spaceNumber));
      }
    },
    []
  );

  const duplicateStatus = useMemo(() => getDuplicateStatus(parkingSpots), [parkingSpots]);

  const selectedSpotStatus = useMemo(() => {
    const result = {};
    parkingSpots?.forEach((spot, index) => {
      result[index] = selectedSpots?.includes(spot.spaceNumber);
    });
    return result;
  }, [parkingSpots, selectedSpots]);

  const parkingSpotsRendered = useMemo(() => {
    return parkingSpots?.map((spot, index) => {
      const isDuplicate = duplicateStatus[index];
      const isSelected = selectedSpotStatus[index];

      return (
        <ParkingSpot

          key={spot.spaceNumber}
          spot={spot}
          isSelected={isSelected}
          handleClick={handleClick}
          isDuplicate={isDuplicate}
        />
      );
    });
  }, [selectedSpots, parkingSpots, duplicateStatus, handleClick]);

  const parkingSpotsTableRendered = useMemo(() => {
    return parkingSpots?.map((spot, index) => {
      const isDuplicate = duplicateStatus[index];
      return (
        <ParkingSpotTable
          key={spot.spaceNumber}
          spot={spot}
          dispatch={dispatch}
          selectedSpots={selectedSpots}
          setSelectedSpot={setSelectedSpot}
          handleSlotClick={handleSlotClick}
          setShowPopupPrice={setShowPopupPrice}
          navigation={navigation}
          isDuplicate={isDuplicate}
          navigate={navigation}
        />
      );
    });
  }, [selectedSpots, parkingSpots, handleSlotClick, , duplicateStatus]);

   const htFixedRef = useRef(null);
      useEffect(() => {
          const htFixedHeight = htFixedRef.current?.offsetHeight || 215;
          const filterHeight = document.querySelector('.pt-filter-height');
           const filterHeight2 = document.querySelector('.mt-filter-height');
          if (filterHeight) {
              filterHeight.style.paddingTop = `${htFixedHeight}px`;
          }
          if (filterHeight2) {
              filterHeight2.style.marginTop = `${htFixedHeight}px`;
          }
          //console.log(htFixedHeight)
      }, [parkingSpaceView]);

  return (
    <>
      <div ref={htFixedRef} className="header-container paking-status-header-container htFixed">
        <SubHeader className="nh-sub">
          <div className="nl-row nh-tab">
            <div
              className={`col-6 nh-menu ${parkingSpaceView === "grid" ? "active" : ""}`}
              onClick={() => dispatch(setParkingSpaceView("grid"))}
            >
              <div>배치 보기</div>
            </div>
            <div
              className={`col-6 nh-menu ${parkingSpaceView === "list" ? "active" : ""}`}
              onClick={() => {
                dispatch(clearSelectedSpots());
                dispatch(setSelectedSpot(null));
                dispatch(setParkingSpaceView("list"))
              }}
            >
              <div>목록 보기</div>
            </div>
          </div>
          <div className="nl-row j-between col nh-tab2">
            <div className={`sub-header-text w-full`}>
              <span className="htColorGray2">주차장명 : </span>
              {user?.parking?.parkingName && (
                <span className="htBold">
                  {user?.parking?.parkingName} ({user.parkingId})
                </span>
              )}
            </div>
            <button className="settings-button" onClick={handleSettingsClick}>
              <img src={settingIcon} alt="setting" />
            </button>
          </div>
        </SubHeader>

        <SearchBar
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={showDropdown}
          onClear={handleClearSearch}
          handleSearchClick={handleSearch}
          searched={isSearched}
          result={result}
        />
        {parkingSpaceView !== "grid" ? <div className="nl-row htFlexShrink0 gap-4 htFontSize18 htColorMain mx-20 pb-5" style={{ borderBottom: '1px solid #e2e5eb' }}>
          <div className="nl-row"><span className="htBold">{parkingSpots?.length}</span><span className="htColor5B5B5B">개중</span></div>
          <div className="nl-row"><span className="htBold">{parkingSpots?.filter((spot) => spot.carNum).length}</span><span className="htColor5B5B5B">개 사용중</span></div>
        </div> : null}
      </div>
      <ToggleComponent isVisible={loading?.parkingSpots}>
        <SkeletonLoader type={parkingSpaceView} />
      </ToggleComponent>

      <ToggleComponent isVisible={!loading?.parkingSpots}>
        <AppInfiniteScroll
          refreshFunction={refreshFunction}
          data={parkingSpots}
          hasMore={false}
          className={"pt-filter-height"}
        >
          <div className={`parking-status-container ${parkingSpaceView === "grid" ? "bg-status-page  has-fixed-buttons" : "pb-20"}`}>



            <ToggleComponent isVisible={parkingSpaceView === "grid"}><div className="parking-grid pb-0">
              {parkingSpotsRendered}

            </div>
            </ToggleComponent>

            <ToggleComponent isVisible={parkingSpaceView === "list"}>

              <div className="table-scroll-wrapper">
                {/* <div
                  className="table-scroll-top"
                  ref={topScrollRef}
                  onScroll={() => handleScroll(topScrollRef, tableScrollRef)}
                >
                  <div style={{ width: tableWidth }}></div>
                </div> */}
                <div
                  className="table-container bg-white"
                  ref={tableScrollRef}
                  onScroll={() => handleScroll(tableScrollRef, topScrollRef)}
                >
                  <table className="parking-table htEdit">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "55px" }}>주차면</th>
                        <th style={{ minWidth: "55px" }}>차량번호</th>
                        <th style={{ minWidth: "55px" }}>입차일시</th>
                        {/* <th style={{ width: "auto" }}>별칭</th> */}
                        <th style={{ minWidth: "65px" }}>입차/출차</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parkingSpotsTableRendered}
                    </tbody>
                  </table>
                </div>
              </div>

            </ToggleComponent>


          </div >
        </AppInfiniteScroll>
        {selectedSpots.length >= 2 && (
          <div className="nl-toggle-message nl-center">주차면 2개가 선택되었습니다</div>
        )}
        {showPopupPrice && (
          <Popup
            title="주차 정보"
            handleYes={() => setShowPopupPrice(false)}
            textYes="닫기"
            onClose={() => setShowPopupPrice(false)}
            setVisible={setShowPopupPrice}
          >

            {
              loadingEntryData ? (
                <div className="nl-row j-center col-12 px-40">
                  <Loading width="30" height="30" />
                </div>

              ) : (
                <div className="nl-row f-column col-12 px-40">
                  <AppInfoRow label="차량번호" value={entryData?.fee?.carNumber} />
                  <AppInfoRow label="입차일시" value={DateTime.fromISO(entryData?.fee?.inTime, { setZone: true }).toFormat("yyyy-MM-dd HH:mm")} />

                  <AppInfoRow label="주차요금" value={numberFormat(entryData?.fee?.feeCalculated || 0, "원")} valueClass="htBold" />
                  {
                    entryData?.fee?.discountDetails?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="htInfoRow"
                        >
                          <span className={`htIrLabel nl-row`}>
                            {item.name}
                          </span>
                          <span className={`htIrValue`}>{numberFormat(-Math.abs(item.fee), "원")}</span>
                        </div>

                      )
                    })
                  }
                  <div className="htInfoRow htBold">
                    <span className="">결제금액</span>
                    <span className="htTotal">{numberFormat(entryData?.fee?.feeFinal || 0, "원")}</span>
                  </div>
                </div>
              )
            }



          </Popup>
        )}
        {parkingSpaceView === "grid" && (
          <ButtonBot
            textYes={`입차하기`}
            handleYes={handleEnterParking}
            disabled={selectedSpots.length === 0}
            totalSpots={parkingSpots?.length}
            usingSpots={parkingSpots?.filter((spot) => spot.carNum).length}
          />
        )}


      </ToggleComponent>
    </>
  );
};

export default ParkingStatusPage;

const ButtonBot = ({ textYes, textNo, textDisable, disabled, handleYes, handleNo, typeYes = "button", typeNo = "button", disable, totalSpots, usingSpots }) => {


  return (
    <div className='button-bot gap-4' style={disable ? { opacity: 0.5 } : {}}>
      {textNo && !disabled && <button type={typeNo} className='button-bot__btn_no' onClick={handleNo}>{textNo}</button>}

      <div className="nl-row htFlexShrink0 gap-4 htFontSize18 htColorMain">
        <div className="nl-row"><span className="htBold">{totalSpots}</span><span className="htColor5B5B5B">개중</span></div>
        <div className="nl-row"><span className="htBold">{usingSpots}</span><span className="htColor5B5B5B">개 사용중</span></div>
      </div>
      {disabled && <button className='button-bot__btn_disable'>{textDisable ? textDisable : textYes}</button>}
      {textYes && !disabled && <button type={typeYes} className='button-bot__btn_yes' onClick={disable ? null : handleYes}>{textYes}</button>}
    </div>
  );
};

const getDuplicateStatus = (spots) => {
  const entryIdCount = {};
  spots?.forEach((spot) => {
    if (spot.entryId) {
      entryIdCount[spot.entryId] = (entryIdCount[spot.entryId] || 0) + 1;
    }
  });
  const result = {};
  spots?.forEach((spot, index) => {
    result[index] = spot.entryId ? entryIdCount[spot.entryId] > 1 : false;
  });
  return result;
};


const ParkingSpot = React.memo(({ spot, isSelected, handleClick, isDuplicate }) => {

  return (
    <div
      className={`parking-slot ${isSelected ? 'selected' : ''} ${isDuplicate ? (spot.membership ? 'htSpotDuplicateMember' : 'htSpotDuplicate') : spot.carNum ? (spot.membership ? 'selected-member' : 'selected2') : ''
        }`}
      onClick={() => handleClick(spot)}
    >
      {spot?.carNum && spot?.inTime && (
        <div className="slot-time-container">
          <img src={IconClock} alt="clock" className="slot-time-icon" />
          <span className="slot-time">
            {datetimeFormat(spot?.inTime, "yyyyMMddHHmmss", "HH:mm") !== 'Invalid DateTime' ?
              datetimeFormat(spot?.inTime, "yyyyMMddHHmmss", "HH:mm") : ''}
          </span>
        </div>
      )}
      <div className="slot-number">{spot.spaceNumber}</div>
      <div className="slot-status slot-parking">
        {spot.carNum ? (
          <>
            <span className="slot-text" style={{ fontWeight: 500 }}>{splitCarNumber(spot.carNum)?.front}</span>
            <span className="slot-car" style={{ fontWeight: 600 }}>{splitCarNumber(spot.carNum)?.back}</span>
          </>
        ) : (
          <>
            <div className="nh-slot">{spot.areaName}</div>
            <div className="nh-slot">({spot.areaTypeName})</div>
          </>
        )}
      </div>

    </div>
  );
});


const ParkingSpotTable = React.memo(({ spot, dispatch, selectedSpots, setSelectedSpot, handleSlotClick, setShowPopupPrice, navigation, isDuplicate, navigate }) => {

  const onRowClick = (e) => {
    e.stopPropagation();
    if (spot.entryId) {
      dispatch(setSelectedSpot(spot));
      navigation("/parking_check_success");
    } else {
      dispatch(setSelectedSpot(null));
      handleSlotClick(spot.spaceNumber);
      setTimeout(() => {
        navigation("/parking_check", {
          state: {
            selectedSpots,
            selectedSpotState: spot,
          },
        });
      }, 0);
    }
  }

  const onCheckFeeClick = (e) => {
    e.stopPropagation();
    if (spot.entryId) {
      dispatch(setSelectedSpot(spot));
      setTimeout(() => {
        navigate("/parking_payment");
      }, 0);

    } else {
      dispatch(setSelectedSpot(null));
      handleSlotClick(spot.spaceNumber);
      setTimeout(() => {
        navigation("/parking_check", {
          state: {
            selectedSpots,
            selectedSpotState: spot,
          },
        });
      }, 0);

    }
  }

  return (
    <tr
      key={spot.spaceNumber}
      onClick={onRowClick}
      className={isDuplicate ? 'mnsDuplicate-table' : ''}
    >
      {/* <td>{spot.spaceNumber}</td> */}
      <td><div className="nh-slot">{spot.areaName}</div>
        <div className="nh-slot">
          {spot.areaTypeName && <>({spot.areaTypeName})</>}
        </div></td>
      <td>{spot.carNum}</td>
      <td>
        {/* <span>{datetimeFormat(spot.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd")}</span> */}
        <span className="ml-5">{datetimeFormat(spot.inTime, "yyyyMMddHHmmss", "HH:mm")}</span>
      </td>
      {/* <td>
        <div className="nh-slot">{spot.areaName}</div>
        <div className="nh-slot">
          {spot.areaTypeName && <>({spot.areaTypeName})</>}
        </div>
      </td> */}
      <td>
        <button
          className={`status-button ${spot.entryId ? "fee-paid" : "entry"}`}
          onClick={onCheckFeeClick}
          style={spot?.outTime ? { opacity: 0.5 } : {}}
        >
          {spot.entryId ? (spot?.outTime ? (spot?.payStatusCd == '020' ? '결제완료' : '미납처리됨') : `출차하기`) : "입차하기"}
        </button>
      </td>
    </tr>
  );
});


const SkeletonLoader = ({
  type = "grid",
}) => {
  return (
    <div className={`mt-filter-height px-20 pt-20`}>
      {/* <div  style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                <Skeleton height={40} width={"100%"} style={{ marginBottom: '20px' }} />
                <Skeleton height={40} width={"100%"} style={{ marginBottom: '20px' }} />
            </div>

            <div style={{ marginBottom: '10px' }}>
                <Skeleton height={40} width="100%" />
            </div>

            <div style={{ marginBottom: '20px' }}>
                <Skeleton height={50} width="100%" />
            </div> */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
        {Array(24).fill().map((_, index) => (
          <Skeleton key={index} height={80} />
        ))}
      </div>
    </div>
  );
}


